module.exports = __webpack_public_path__ + "static/media/4-check.e528394d.svg";